import { gsap } from "@gsap/shockingly";

export const onLoad = () => {
  document.onreadystatechange = function () {
    if (document.readyState === "interactive") {
      document.body.classList.remove("loading");

    // comment this line for a pulsing effect on load 

    //   gsap.from("body", {
    //     opacity: 0,
    //     duration: 1,
    //     ease: "Power3.easeInOut",
    //   });

      document.body.classList.add("loaded");
    }
  };
};
